var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodCategoryNonVeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2C0.75 1.30964 1.30964 0.75 2 0.75H18C18.6904 0.75 19.25 1.30964 19.25 2V18C19.25 18.6904 18.6904 19.25 18 19.25H2C1.30964 19.25 0.75 18.6904 0.75 18V2Z",
    stroke: "#E50B20",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47139 5.30362C9.70178 4.89879 10.2982 4.89879 10.5286 5.30362L15.548 14.123C15.772 14.5165 15.4805 15 15.0194 15H4.98058C4.5195 15 4.22805 14.5165 4.45197 14.123L9.47139 5.30362Z",
    fill: "#E50B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodCategoryNonVeg);
export default __webpack_public_path__ + "static/media/food-category-non-veg.433f33798a64d36cb1ced2716be82a8e.svg";
export { ForwardRef as ReactComponent };